export default __webpack_public_path__ + "static/media/compare.69398981.svg";